import React from 'react';
import { Flex, Text, Box } from 'rebass';
import { FiLoader } from 'react-icons/fi';
import { keyframes } from '@emotion/react';
import Progress from './Progress';
import Grid from 'app/grid/index';

export const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

function BufferingOverlay({
  children,
  isBuffering = false,
  bg = 'rgba(0,0,0,.35)',
  mainProgress,
  showLoadingText = false,
  isFromPoster,
  color = "greys.1",
  loadingText = <>
    Our hamsters are hard at <br />
    work crafting your PDF,
    <br /> layer by layer 🐹
    <br />
    <br />
    This can take up to 3 minutes.
  </>,
  sx = {},
  boxSx,
  opacity = '.35',
  showHeaderText = false,
  headingText = undefined,
  ...props
}) {

  return (
    <Grid >
      <Box sx={{ gridArea: '1 / 1 / 2 / 2', ...boxSx }} {...props}>{children}</Box>
      {isBuffering && (
        <Flex
          alignItems="center"
          justifyContent="center"
          flexDirection="column"
          bg={bg}
          sx={{
            gridArea: '1 / 1 / 2 / 2',
            zIndex: 5,
            p: 4,
            boxShadow: `inset 0 0 50px rgba(0,0,0,${opacity})`,
            ...sx,
          }}
          id="buffering-overlay" 
        >
          {showHeaderText && (
            <Text color={color} className="loading" fontFamily='Bitter' fontWeight={500} fontSize={'30px'} mb={2} lineHeight="165%">
              {headingText}
            </Text>
          )}
          <Text
            as={FiLoader}
            color={color}
            size={isFromPoster ? 720 : 72}
            sx={{
              animation: `${rotate} 4s linear infinite`,
              boxShadow: '1p 1px 8px rgba(0,0,0,.75)',
            }}
          />
          {showLoadingText && (
            <Text color={color} className="loading">
              {loadingText}
            </Text>
          )}
        </Flex>
      )}

      {mainProgress > 0 && mainProgress <= 100 && (
        <Box
          alignItems="center"
          justifyContent="center"
          bg={bg}
          sx={{ gridArea: '1 / 1 / 2 / 2', zIndex: 3, boxShadow: `inset 0 0 50px rgba(0,0,0,${opacity})` }}
          p={2}
          mt={-80}
          width="100%"
        >
          <Box
            sx={{
              position: 'relative',
              width: '100%',
              padding: '32px',
              marginTop: '30%',
              bottom: '80px',
            }}
          >
            <Text
              textAlign="left"
              color="white"
              className='loading'
              pb={1}
              lineHeight="120%"
            >
              Loading
            </Text>
            <Progress percentComplete={mainProgress} mb={4} />
          </Box>
        </Box>
      )}
    </Grid>
  );
}

export default BufferingOverlay;
